export const ApiConfig = {
    //地图服务地址
    MapURL: 'http://223.105.73.45:10052/api/styles/style',
    //信号灯
    SignalLight2: 'http://223.105.73.45:10000/searchDeviceInfo?deviceType=all',
    SignalLight: 'http://223.105.73.45:10005/facilityPoint',
    //SignalLight: '/prod-api/searchDeviceInfo?deviceType=all',
    //出租车
    //TaxiGps: 'http://36.155.95.15:19000/taxi/gps', 'http://192.168.1.142:8089
   TaxiGps: '/taxi/gps',
    //天气
    weather:'https://restapi.amap.com/v3/weather/weatherInfo?city=320200&key=93f658680d5bde1f63217f803dc434f4&extensions=all',
    //
    CompanyCountResponse:'http://223.105.73.45:10045/iov/getCarStatus/count',


    //ws接口
     //公交车
     BusGps: 'http://223.105.73.45:10051/webSocket',
     //网联车
     RobotGps: 'http://223.105.73.45:10044/iov',
      //RobotGps: '/iov',

     //山水城环卫车
     sscRobotGps: 'http://223.105.73.45:10002/otheriov',
     
    // 登录接口
    Login: 'http://223.105.73.45:10045/console/login'
}

